import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';

import local from './formElementStyles/closeButton.module.css';

const CloseButton = ({ id, onClose }) => {
    return (
        <button
            id={`close_button_${id}`}
            data-testid={`close_button_${id}`}
            type="button"
            className={local.closeButtonGroup}
            onClick={onClose}
            aria-label="Close details">
            Close details
            <CloseIcon />
        </button>
    );
};

CloseButton.propTypes = {
    id: PropTypes.string,
    onClose: PropTypes.func
};

export default CloseButton;
